const INITIAL_STATE = {
  perfis: [],
  perfil: {},
  cadastro: {
    nome: '',
    tipo: ''
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PARCEIRO_PERFIL_FETCH':
      return { ...state, perfis: action.payload }
    case 'PARCEIRO_PERFIL_EDITAR':
      return { ...state, perfil: action.payload }
    case 'PARCEIRO_PERFIL_INPUT_CHANGE': {
      const cadastroCopy = { ...state.cadastro }
      cadastroCopy[action.campo] = action.payload

      return { ...state, cadastro: cadastroCopy }
    }
    default:
      return state
  }
}